<div class="edit-section">
	<ng-container *ngIf="showCreviceOnly&&!isLayerTopologyState">
		<div class="operation-section">
			<div class="card-button-group">
				<button (click)="clickConfirm()">Confirm</button>
			</div>
		</div>
		<div class="edit-content">
			<div class="topo-error-type">
				<div class="error-title">
					<div class="expand-icon">
						<i *ngIf="creviceObj.list.length" class="glyphicons" [ngClass]="{'glyphicons-plus-sign': !creviceObj.isExpand, 'glyphicons-minus-sign': creviceObj.isExpand}" (click)="toggleTopoErrorExpand(creviceObj)"></i>
					</div>
					<label>{{creviceObj.label + ' (' + creviceObj.list.length + ')'}}</label>
				</div>
				<div *ngIf="creviceObj.isExpand && creviceObj.list.length" class="error-list">
					<div class="rows-wrap">
						<div *ngFor="let item of creviceObj.list; let idx2 = index" [ngClass]="{'current-selected': item === currentSelected}" (click)="clickRow(item, creviceObj)">
							<div class="row-line">
								<div class="row-cell" (click)="item.isGeomShow=!item.isGeomShow">
									<i class="glyphicons" [ngClass]="{'glyphicons-plus-sign': !item.isGeomShow, 'glyphicons-minus-sign': item.isGeomShow}"></i>
								</div>
							</div>
							<div class="geom-section">
								<app-feature-coordinates-display *ngIf="item.isGeomShow" [coordinates]="item.geomJson.coordinates||[]" [isExpand]="true"></app-feature-coordinates-display>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="!showCreviceOnly||isLayerTopologyState">
		<div class="operation-section">
			<div class="card-button-group">
				<button *ngIf="showResolveBtn" class="button-general" title="Automatically resolve gaps and overlaps" (click)="clickResolve()">Resolve</button>
				<button *ngIf="showCommitBtn" class="button-general" [disabled]="disableCommitBtn" (click)="clickCommit()">Commit</button>
			</div>
		</div>
		<div class="edit-content">
			<div *ngIf="showToggleResolved" class="resolve-toggle">
				<label>Topo Errors</label>
                    <mat-slide-toggle
                        [(ngModel)]="isShowResolvedLayer"
                        (change)="toggleResolved()">
                    </mat-slide-toggle>
				<label>Resolved</label>
				<!-- <button (click)="toggleResolved()">toggle resolved</button> -->
			</div>
			<div *ngFor="let topoErrorObj of topoErrorList; let idx = index;" class="topo-error-type">
				<div class="error-title">
					<div class="expand-icon">
						<i *ngIf="topoErrorObj.list.length" class="glyphicons" [ngClass]="{'glyphicons-plus-sign': !topoErrorObj.isExpand, 'glyphicons-minus-sign': topoErrorObj.isExpand}" (click)="toggleTopoErrorExpand(topoErrorObj)"></i>
					</div>
					<label>{{topoErrorObj.label + ' (' + topoErrorObj.list.length + ')'}}</label>
				</div>
				<div *ngIf="topoErrorObj.isExpand && topoErrorObj.list.length" class="error-list">
					<div class="header-line">
						<div *ngFor="let header of headers" class="header-cell">{{header.name}}</div>
					</div>
					<div class="rows-wrap">
						<div *ngFor="let item of topoErrorObj.list; let idx2 = index" [ngClass]="{'current-selected': item === currentSelected}" (click)="clickRow(item, topoErrorObj)">
							<div class="row-line">
								<div class="row-cell" (click)="item.isGeomShow=!item.isGeomShow">
									<i class="glyphicons" [ngClass]="{'glyphicons-plus-sign': !item.isGeomShow, 'glyphicons-minus-sign': item.isGeomShow}"></i>
								</div>
								<div class="row-cell" [title]="item.ori_gids.join(', ')">{{item.ori_gids.join(', ')}}</div>
							</div>
							<div class="geom-section">
								<app-feature-coordinates-display *ngIf="item.isGeomShow" [coordinates]="item.coordinates||[]" [isExpand]="true"></app-feature-coordinates-display>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>